import { render, staticRenderFns } from "./TermsAndConditionsHeader.vue?vue&type=template&id=212e69ac&scoped=true"
import script from "./TermsAndConditionsHeader.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsHeader.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsHeader.vue?vue&type=style&index=0&id=212e69ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e69ac",
  null
  
)

export default component.exports